export function approxEqual(a: number, b: number, epsilon = 1e-6) {
  if (a === b) {
    return true
  }
  if (typeof a !== "number" || typeof b !== "number") {
    return false
  }
  const diff = Math.abs(a - b)
  const maxAbs = Math.max(Math.abs(a), Math.abs(b))
  return diff / maxAbs <= epsilon
}

export function formatDateTime(d: Date) {
  return (
    formatDate(d) +
    "_" +
    (d.getHours() < 10 ? "0" : "") +
    d.getHours() +
    (d.getMinutes() < 10 ? "0" : "") +
    d.getMinutes()
  )
}

export function formatDate(d: Date) {
  let month = "" + (d.getMonth() + 1)
  let day = "" + d.getDate()
  const year = d.getFullYear()

  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day

  return [year, month, day].join("")
}

export function formatToSignificantDigits(
  number: number,
  significantDigits: number
) {
  if (isNaN(number) || !isFinite(number)) {
    throw new Error("Invalid input: 'number' must be a finite number")
  }
  if (!Number.isInteger(significantDigits) || significantDigits <= 0) {
    throw new Error(
      "Invalid input: 'significantDigits' must be a positive integer"
    )
  }

  // Large numbers: show full integer to avoid truncating significant integer digits
  if (Math.abs(number) >= Math.pow(10, significantDigits)) {
    return Math.round(number).toString()
  }

  const result = number.toPrecision(significantDigits)

  // Boundary spillover: toPrecision may produce scientific notation
  // (e.g. 9999.9 with 4 sig digits → "1.000e+4"), fall back to integer
  if (result.includes("e")) {
    return Math.round(number).toString()
  }

  return result
}
